<template>
<component-module moduleName="dashboard_module">
    <template v-slot:programName>Dashboard</template>
</component-module>
</template>

<script>
import './dashboard.scss'
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
    name: 'Dashboard',
    data() {
        return {

        }
    },
    created() {
        // this.bootstrapModule()
    },
    watch: {
        getUser(newVal, oldVal) {
            if (!oldVal.user_name && newVal.user_name) {
                // this.bootstrapModule()
            }
        }
    },
    computed: {
        isReady() {
            return !this.getLoadingModule
        },
        ...mapGetters('dashboard_module', [
            'getLoadingModule'
        ])
    },
    methods: {
        ...mapActions('dashboard_module', [
            'bootstrapModule'
        ])
    }
}
</script>
